export default __webpack_public_path__ + "static/Verlag-Bold-0d664c3e1b666c4300f02c9b88abafbb.woff2";